<template>
  <div class="home">
    <div class="imgbox">
      <!-- 最外层div设置为绝对定位 -->
      <div style="position: absolute;">
        <img class="box-img" src="../assets/banner.png">
        <div class="box-font">政策法规</div>
      </div>
    </div>
    <article class="newhome" v-cloak style="padding-bottom: 100px;">
      <div style="display: flex;margin-top: 40px;">
        <div>
          <!--登录-->
          <leftlogin :formData.sync="form"></leftlogin>
        </div>
        <div style="margin-left: 20px;padding:20px;width:100%; border: 1px solid #CCCCCC;">
          <h3 style="text-align: center;">{{ detail.Title }}</h3>
          <p style="text-align: center;font-size: 16px;">{{ detail.CreateTime.slice(0, 10) }}</p>
          <!-- <a style="float: right;padding-right: 30px;color:red;" :href="detail.Annex" v-show="detail.Annex">下载附件</a> -->
          <div style="padding-top: 30px;" v-html=detail.Content></div>
        </div>

      </div>
    </article>
  </div>
</template>

<script>
// @ is an alias to /src
import leftlogin from "../components/leftlogin.vue";
export default {
  name: "home",
  components: { leftlogin },
  data() {
    return {
      detail: {},
      Id: 0,
      form: {}
    };
  },
  created() {
    this.Id = this.$route.query.id;
    this.getData();
  },
  methods: {
    getData() {
      var that = this;
      that.$api.get("/Policy/" + that.Id, null, r => {
        that.detail = r.response;
        that.Content = that.detail.Content;
      });
    },
    getData1() {
      var that = this;
      that.$api.get("/Notice/" + that.Id, null, r => {
        that.detail = r.response;
      });
    },
    contentshow(item) {
      var that = this;
      that.Id = item.Word_Value;
      that.getData();
      return false;
    }
  },
  watch: {
    $route(to) {
    }
  },
  computed: {

  }
};
</script>

<style>
article.newhome {
  width: 1300px;
}

.el-table .cell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

input::-webkit-input-placeholder {
  color: #999999;
  padding: 10px 0px 16px 10px;
}

.pagination {
  text-align: center;
}

.frame-border {
  width: 204px;
  border: 1px solid #EEEEEE;
}

.lmenu {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #222222;
  font-size: 18px;
}

.imgbox {
  height: 320px;
}

.box-img {
  height: 320px;
  position: relative;
  /*相对布局*/
}

.box-font {
  position: absolute;
  /*绝对布局*/
  z-index: 1;
  /*置于上层*/
  display: inline;
  top: 35%;
  right: 45%;
  height: 66px;
  font-size: 50px;
  font-weight: bold;
  color: #FFFFFF;
  letter-spacing: 10px;
}
</style>
